import MUIPopper, { PopperProps } from "@mui/material/Popper";
import React, { FC } from "react";

export const Popper: FC<PopperProps> = (props) => (
  <MUIPopper {...props as any} />
);
